var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gym-edit-viewer"},[_c('v-container',{attrs:{"fluid":""}},[_c('gym-viewer',{attrs:{"items":_vm.localValue,"new-window":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }